import React, { FC } from 'react';
import _ from 'lodash';
import { Box, Text, Range, Input } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import useFormattedCurrency from '../../../Hooks/useFormattedCurrency';
import { useExploreContext } from '../../../Contexts/ExploreContext';

type Props = {
  value: any;
  setValue: any;
  hasMax: any;
  setHasMax: any;
};

const Budget: FC<Props> = ({ value, setValue, hasMax, setHasMax }) => {
  const { t } = useTranslation();
  const {
    state: { userCurrency },
  } = useExploreContext();
  const { symbol } = useFormattedCurrency({ currency: userCurrency });

  return (
    <>
      <Box
        align="space-between"
        paddingTop="18px"
        paddingBottom="6px"
        dataHook="mobile-budget-filter"
      >
        <Range>
          <Input
            dataHook="min-price-input"
            prefix={<Input.Affix>{symbol}</Input.Affix>}
            value={value.min}
            onChange={(e: any) => {
              setValue({ min: Number(e.target.value), max: value.max });
            }}
            type="number"
          />

          <Input
            dataHook="max-price-input"
            prefix={<Input.Affix>{symbol}</Input.Affix>}
            value={!hasMax ? `${value.max}+` : value.max}
            maxLength={10}
            onChange={(e: any) => {
              if (_.isFinite(_.toNumber(e.target.value))) {
                setHasMax(true);
                setValue({ min: value.min, max: Number(e.target.value) });
              }
            }}
          />
        </Range>
      </Box>
      <Box>
        <Box width="50%">
          <Text secondary light size="small" weight="thin">
            {t('mobile-filter-minimum-label')}
          </Text>
        </Box>
        <Box width="50%">
          <Text secondary light size="small" weight="thin">
            {t('mobile-filter-maximum-label')}
          </Text>
        </Box>
      </Box>
    </>
  );
};

export default Budget;
